import styled from 'styled-components';

export const OrangeDot = styled.div`
  width: 10px;
  height: 10px;
  background-color: var(--yellow);
  border-radius: 100%;
  margin-right: 15px;
`;
